/* eslint-disable */
export default {
  ringtones: 'Toques',
  incomingRingtone: 'Toque de chamada recebida',
  outgoingRingtone: 'Toque de chamada realizada',
  play: 'Reproduzir',
  stop: 'Parar',
  upload: 'Carregar',
  reset: 'Restaurar',
  save: 'Salvar',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
